import {
  useEffect,
  useState,
  useRef
} from "react";

export function useOnScreen(ref: React.MutableRefObject<any>) {
  const [ isOnScreen, setIsOnScreen ] = useState(false);
  const observerRef = useRef<IntersectionObserver>(null);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore cant remove the readonly properties
    observerRef.current = new IntersectionObserver(([ entry ]) =>
      setIsOnScreen(entry.isIntersecting)
    );
  }, []);

  useEffect(() => {
    observerRef.current?.observe(ref.current);

    return () => {
      observerRef.current?.disconnect();
    };
  }, [ ref ]);

  return isOnScreen;
}
